import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Trophy, Coins, Sparkles } from "lucide-react";

const TIER_STYLES = {
  rookie:   "bg-zinc-500 text-white",
  explorer: "bg-emerald-500 text-white",
  guardian: "bg-sky-500 text-white",
  legend:   "bg-amber-500 text-white",
};

export default function LandingLeaderboard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/gamification/leaderboard/public").then(r => setData(r.data)).catch(() => {}); }, []);
  if (!data || !data.rows?.length) return null;

  const membersText = data.members_count >= 100
    ? `${(Math.floor(data.members_count / 100) * 100).toLocaleString()}+`
    : data.members_count.toLocaleString();

  return (
    <section className="py-16 px-6 lg:px-8" data-testid="landing-leaderboard">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
          <div>
            <div className="text-[11px] tracking-widest uppercase text-primary font-medium mb-2 flex items-center gap-2">
              <Sparkles className="w-3.5 h-3.5" /> Community
            </div>
            <h2 className="font-display text-3xl md:text-4xl leading-tight">
              Join <span className="text-primary font-semibold">{membersText} Guardians</span> earning gems every month.
            </h2>
            <p className="text-muted-foreground mt-2 max-w-xl text-sm">
              Every plan holder — even free Finder members — earns gems. Spin daily. Enter our monthly £100 raffle. This month's top spinners:
            </p>
          </div>
          <div className="hidden md:flex items-center gap-2 text-xs text-muted-foreground">
            <Trophy className="w-4 h-4 text-amber-500" />
            Updated live · Names anonymised
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-3">
          {data.rows.slice(0, 10).map((r, i) => (
            <div
              key={i}
              className="flex items-center justify-between p-3 rounded-lg bg-card border border-border hover:border-primary/40 transition-colors"
              data-testid={`leaderboard-row-${i}`}
            >
              <div className="flex items-center gap-3">
                <span className={`w-8 h-8 rounded-full flex items-center justify-center font-mono text-xs font-semibold ${i < 3 ? "bg-amber-500 text-white" : "bg-muted text-muted-foreground"}`}>
                  #{i + 1}
                </span>
                <div>
                  <div className="font-medium text-sm">{r.name}</div>
                  <div className={`inline-block text-[9px] px-1.5 py-0.5 rounded uppercase tracking-wide ${TIER_STYLES[r.tier] || "bg-muted"}`}>{r.tier}</div>
                </div>
              </div>
              <div className="flex items-center gap-1 font-mono text-sm">
                <Coins className="w-3.5 h-3.5 text-amber-500" />
                <span className="font-semibold">{r.gems.toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
